import { SkipNext } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { skipTask } from './model'

export const RedoButton = () => (
  <IconButton onClick={() => skipTask()}>
    <SkipNext fontSize="large" />
  </IconButton>
)
